import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { useMatchMedia } from 'hooks/useMatchMedia';
import { CarouselProvider, Slide, Slider } from 'pure-react-carousel';
import promoBreakpoints from 'theme/promoBreakpoints';
import promoMedia from 'theme/promoMedia';

import { WAIT_BEFORE_SLIDES_IS_ACTIVE } from './Constants';
import { StepBlock } from '../StepBlock/StepBlock';

const Container = styled.div`
    margin: 0 -4px;
    padding-bottom: 32px;

    ${promoMedia.tablet744} {
        margin: 0 -8px;
        padding-bottom: 48px;
    }

    ${promoMedia.desktop1440} {
        padding-bottom: 64px;
    }

    .carousel {
        ${promoMedia.tablet744} {
            max-width: 504px;
        }

        ${promoMedia.desktop1440} {
            max-width: 100%;
        }
    }
`;

const StepBlockSlide = styled.div`
    padding: 0 4px;
    min-height: 100%;
    width: 100%;
    box-sizing: border-box;
    display: flex;

    ${promoMedia.tablet744} {
        padding: 0 8px;
    }
`;

const StepBlockContainer = styled.div`
    display: flex;
    justify-content: center;
`;

const DesktopStepBlockContainer = styled.div`
    padding: 0 12px;
    width: 158px;
`;

export const StepBlockSection = (props) => {
    const isDesktop = useMatchMedia(promoBreakpoints.desktop1440);
    const isTablet = useMatchMedia(promoBreakpoints.tablet744);
    const hasData = props.data && Array.isArray(props.data);
    const totalSlides = hasData ? props.data?.length : null;

    return (
        <Container>
            {!isDesktop ? (
                <CarouselProvider
                    naturalSlideHeight="100%"
                    naturalSlideWidth="100%"
                    totalSlides={totalSlides}
                    visibleSlides={isTablet ? 3.5 : 2.3}
                    interval={WAIT_BEFORE_SLIDES_IS_ACTIVE}
                    infinite
                    isPlaying={!__isDev__}
                    isIntrinsicHeight
                >
                    <Slider>
                        {hasData &&
                            props.data
                                .filter((item) => item !== null)
                                .map((item, index) => {
                                    return (
                                        <Slide index={index} key={item.id}>
                                            <StepBlockSlide>
                                                <StepBlock number={item.number} text={item.text} isReversed={item.isReversed} />
                                            </StepBlockSlide>
                                        </Slide>
                                    );
                                })}
                    </Slider>
                </CarouselProvider>
            ) : (
                <StepBlockContainer>
                    {Array.isArray(props.data) &&
                        props.data
                            .filter((item) => item !== null)
                            .map((item) => {
                                return (
                                    <DesktopStepBlockContainer key={item.id}>
                                        <StepBlock number={item.number} text={item.text} isReversed={item.isReversed} />
                                    </DesktopStepBlockContainer>
                                );
                            })}
                </StepBlockContainer>
            )}
        </Container>
    );
};

StepBlockSection.propTypes = {
    data: PropTypes.array,
};
